var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.666667, 2.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.11111111,2.60008311e-11 C9.35631362,2.60008311e-11 12.0107571,2.02365477 12.2101932,4.57963086 C11.37156,4.14715732 10.3839222,3.9 9.33333333,3.9 C6.36549838,3.9 3.9,5.8723919 3.9,8.4 C3.9,8.83878625 3.97429992,9.26084015 4.11262954,9.65874787 L2.31649,10.9421278 C2.114255,11.0865944 1.83333333,10.9420056 1.83333333,10.6934667 L1.83333333,8.38022778 C0.701946667,7.49295556 4.43201031e-13,6.25649444 4.43201031e-13,4.88888889 C4.43201031e-13,2.18882889 2.73603611,2.60008311e-11 6.11111111,2.60008311e-11 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,8.4 C14,10.4618733 11.91064,12.1333333 9.33333333,12.1333333 C8.84184,12.1333333 8.36812667,12.0725733 7.923244,11.9598733 L6.43562267,13.0224733 C6.28118867,13.1327933 6.06666667,13.02238 6.06666667,12.8325867 L6.06666667,11.0661133 C5.20269867,10.38856 4.66666667,9.44435333 4.66666667,8.4 C4.66666667,6.338136 6.75600333,4.66666667 9.33333333,4.66666667 C11.91064,4.66666667 14,6.338136 14,8.4 Z",
    transform: "translate(9.333333, 8.866508) scale(-1, 1) translate(-9.333333, -8.866508) "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.7a14e078b271bf55e2b606096e187fa2.svg";
export { ForwardRef as ReactComponent };